import { reactive } from "@nuxtjs/composition-api";
import useOpenClose from "./useOpenClose";
const dialogs = reactive({});
function useModalDialog(id) {
  dialogs[id] = dialogs[id] || useOpenClose();
  return dialogs[id];
}
var useModalDialog_default = useModalDialog;
export {
  useModalDialog_default as default
};
